module.exports = __webpack_public_path__ + "static/media/15UN-Habitat12.5cec1937.jpg";